export default __webpack_public_path__ + "static/media/photo.2d7a3c48.png";